import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

export interface ConfirmDeleteDialogData {
  onConfirmDelete: () => void;
  onCancel: () => void;
  type: string;
}

@Component({
  selector: 'app-confirm-delete-popup',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatProgressSpinner],
  templateUrl: './confirm-delete-popup.component.html',
  styleUrls: ['./confirm-delete-popup.component.css'],
})
export class ConfirmDeletePopupComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDeletePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDeleteDialogData
  ) {}
  loading: boolean = false;
  type: string = 'Report';
  ConfirmDelete(): void {
    this.data.onConfirmDelete();
    this.loading = true;

  }

  cancel(): void {
    this.data.onCancel();
    this.dialogRef.close();
  }
}
